export const gradeConstants = {
  GETALL_REQUEST: 'GRADES_GETALL_REQUEST',
  GETALL_SUCCESS: 'GRADES_GETALL_SUCCESS',
  GETALL_FAILURE: 'GRADES_GETALL_FAILURE',

  CREATE_REQUEST: 'GRADE_CREATE_REQUEST',
  CREATE_SUCCESS: 'GRADE_CREATE_SUCCESS',
  CREATE_FAILURE: 'GRADE_CREATE_FAILURE',

  UPDATE_REQUEST: 'GRADE_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'GRADE_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'GRADE_UPDATE_FAILURE',

  DELETE_REQUEST: 'GRADE_DELETE_REQUEST',
  DELETE_SUCCESS: 'GRADE_DELETE_SUCCESS',
  DELETE_FAILURE: 'GRADE_DELETE_FAILURE',
};
